__turbopack_context__.v({
  "lock-layer": "EmailSignatureLockLayer-module-scss-module__cq2u3W__lock-layer",
  "lock-layer-for-input": "EmailSignatureLockLayer-module-scss-module__cq2u3W__lock-layer-for-input",
  "lock-message": "EmailSignatureLockLayer-module-scss-module__cq2u3W__lock-message",
  "lock-message-container": "EmailSignatureLockLayer-module-scss-module__cq2u3W__lock-message-container",
  "lock-message-wrapper": "EmailSignatureLockLayer-module-scss-module__cq2u3W__lock-message-wrapper",
});
